import React from 'react';
import { Plus, X } from 'lucide-react';

const ImagePreviewGrid = ({
  imagePreviews,
  removeImage,
  isProcessing,
  isMobile = false,
  fileInputRef,
  handleImageSelect
}) => {
  const cellH = isMobile ? 96 : 128;
  const gap = 8;
  // 2행 * 셀높이 + 1gap = 딱 2줄만 보임, 그 이상은 스크롤
  const maxHeight = cellH * 2 + gap;

  return (
    <div
      className="grid grid-cols-2 gap-2"
      style={{ minHeight: `${maxHeight}px`, maxHeight: `${maxHeight}px`, overflowY: 'auto' }}
    >
      {/* 첫 번째 셀: 업로드 추가 버튼 */}
      <div
        style={{ height: `${cellH}px` }}
        className={`border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center transition-colors
          ${isProcessing ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-blue-400 hover:bg-blue-50'}`}
        onClick={() => !isProcessing && fileInputRef?.current?.click()}
      >
        <Plus size={22} className="text-gray-400 mb-1" />
        <p className="text-xs text-gray-500">사진 추가</p>
      </div>

      {/* 선택된 이미지 셀들 */}
      {imagePreviews.map((preview, index) => (
        <div key={preview.id} className="relative" style={{ height: `${cellH}px` }}>
          <img
            src={preview.url}
            alt={preview.name}
            className="w-full h-full object-cover rounded-lg border"
          />
          <button
            onClick={() => removeImage(index)}
            disabled={isProcessing}
            className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-0.5 disabled:opacity-50"
          >
            <X size={12} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ImagePreviewGrid;
